var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/text_character_counter.tsx";
import classNames from 'classnames';
import React from 'react';
import { length } from 'stringz';
const TextCharacterCounter = ({
  text,
  max
}) => {
  const checkRemainingText = diff => {
    return /*#__PURE__*/React.createElement("span", {
      className: classNames('text-sm font-semibold', {
        'text-gray-400': diff >= 0,
        'text-danger-600': diff < 0
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 7
      }
    }, diff);
  };
  const diff = max - length(text);
  return checkRemainingText(diff);
};
export default TextCharacterCounter;